import type { RecommendItem } from "@/types/film";

export const recommendList: RecommendItem[] = [
  {
    id: "r1",
    title: "夏日回声",
    year: "2021",
    genre: "剧情 / 成长",
    rating: "8.4",
    summary:
      "一个关于夏天、海边与第一次告别的故事。少年在漫长的假期里学会了如何面对失去，也第一次理解了成长的含义。",
    image:
      "https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20design%20with%20warm%20peach%20and%20amber%20tones%2C%20abstract%20sunlit%20seaside%20composition%2C%20elegant%20gradient%20background%2C%20soft%20artistic%20style%2C%20high%20detail&width=800&height=1200&seq=peach-rec-01&orientation=portrait",
  },
  {
    id: "r2",
    title: "归途列车",
    year: "2019",
    genre: "剧情 / 家庭",
    rating: "8.1",
    summary:
      "一列穿越大半个国家的夜车，载着几个素不相识的人。每到一站，都有人下车，也有人带着新的故事上来。",
    image:
      "https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20design%20with%20warm%20amber%20tones%2C%20abstract%20train%20window%20and%20dusk%20sky%20composition%2C%20elegant%20gradient%20background%2C%20artistic%20style%2C%20high%20detail&width=800&height=1200&seq=peach-rec-02&orientation=portrait",
  },
  {
    id: "r3",
    title: "十七岁的海",
    year: "2022",
    genre: "青春 / 剧情",
    rating: "7.9",
    summary:
      "小城少女在海边度过最后一个高中暑假，她第一次认真地望向远方，也第一次认真地望向自己。",
    image:
      "https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20design%20with%20soft%20warm%20orange%20tones%2C%20abstract%20sea%20horizon%20composition%2C%20elegant%20gradient%20background%2C%20artistic%20style%2C%20high%20detail&width=800&height=1200&seq=peach-rec-03&orientation=portrait",
  },
  {
    id: "r4",
    title: "白露为霜",
    year: "2018",
    genre: "文艺 / 剧情",
    rating: "8.6",
    summary:
      "一位老匠人在手艺与时代之间做出抉择。影片以极其克制的镜头语言，记录了一段终将逝去的手艺与人心。",
    image:
      "https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20design%20with%20muted%20warm%20beige%20and%20amber%20tones%2C%20abstract%20craft%20and%20light%20composition%2C%20elegant%20gradient%20background%2C%20high%20detail&width=800&height=1200&seq=peach-rec-04&orientation=portrait",
  },
  {
    id: "r5",
    title: "四月的城市",
    year: "2023",
    genre: "都市 / 爱情",
    rating: "7.6",
    summary:
      "两个在城市里擦肩而过又重逢的人。四月的雨很多，他们却花了一整个春天才把话说清楚。",
    image:
      "https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20design%20with%20warm%20rainy%20city%20amber%20glow%2C%20abstract%20urban%20composition%2C%20elegant%20gradient%20background%2C%20artistic%20style%2C%20high%20detail&width=800&height=1200&seq=peach-rec-05&orientation=portrait",
  },
  {
    id: "r6",
    title: "春分",
    year: "2020",
    genre: "剧情 / 治愈",
    rating: "8.2",
    summary:
      "春天到来的时候，小镇上的人们各自面对着自己的变化。影片温柔地告诉他们，一切都会好起来。",
    image:
      "https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20design%20with%20fresh%20warm%20spring%20peach%20tones%2C%20abstract%20blossom%20composition%2C%20elegant%20gradient%20background%2C%20artistic%20style%2C%20high%20detail&width=800&height=1200&seq=peach-rec-06&orientation=portrait",
  },
  {
    id: "r7",
    title: "长街",
    year: "2017",
    genre: "剧情 / 年代",
    rating: "8.8",
    summary:
      "一条老街，几户人家，几十年的光阴。影片用平实的方式，讲述了一个普通街区里不普通的岁月。",
    image:
      "https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20design%20with%20warm%20sepia%20and%20amber%20tones%2C%20abstract%20old%20street%20composition%2C%20elegant%20gradient%20background%2C%20high%20detail&width=800&height=1200&seq=peach-rec-07&orientation=portrait",
  },
  {
    id: "r8",
    title: "乡镇纪事",
    year: "2024",
    genre: "纪实 / 剧情",
    rating: "7.8",
    summary:
      "一名年轻医生来到偏远乡镇的第一年。他记录下了这里的人、这里的四季，也记录下了自己的改变。",
    image:
      "https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20design%20with%20warm%20rural%20amber%20and%20peach%20tones%2C%20abstract%20countryside%20composition%2C%20elegant%20gradient%20background%2C%20high%20detail&width=800&height=1200&seq=peach-rec-08&orientation=portrait",
  },
];